import React, { Component } from 'react';

export default class ZoomImage extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handlePlaceHolderLoad = this.handlePlaceHolderLoad.bind(this);
    this.state = { x: 0, y: 0, xp: 0, yp: 0, fullWidth: null, fullHeight: null, boxVisible: false };
  }

  handleMouseMove(e) {
    const bounds = e.target.getBoundingClientRect();
    const x = e.clientX - bounds.left;
    const y = e.clientY - bounds.top;
    const xp = x / (bounds.right - bounds.left);
    const yp = y / (bounds.bottom - bounds.top);
    this.setState({...this.state, x, y, xp, yp});
}

handleMouseOver(e) {
  this.setState({...this.state, boxVisible: true});
  }

handleMouseOut(e) {
  this.setState({...this.state, boxVisible: false});
  }

handlePlaceHolderLoad(e) {
  const dpr = (window.devicePixelRatio || 1);
  const fullWidth = e.target.naturalWidth / dpr;
  const fullHeight = e.target.naturalHeight / dpr;
  this.setState({...this.state, fullWidth, fullHeight});
  }

render() {
  const containerStyle = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%'
  };

  const smallImageStyle = {
    width: '100%',
    height: 'auto',
    cursor: 'zoom-in'
  };

  let widgetWidth, widgetHeight = 0;
  if (this.container) {
    widgetWidth = this.container.clientWidth;
    widgetHeight = this.container.clientHeight;
  }

  const largeImageStyle = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundImage: `url(${this.props.largeImageSrc})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: `${-this.state.xp * (this.state.fullWidth - widgetWidth)}px ${-this.state.yp * (this.state.fullHeight - widgetHeight)}px`,
    backgroundSize: `${this.state.fullWidth || 100}px ${this.state.fullHeight || 100}px`,
    border: '1px solid white',
    pointerEvents: 'none',
    display: this.state.boxVisible ? 'block' : 'none'
  };

  const placeHolderStyle = {
    display: 'none'
  };

  return (
    <div {...this.props} style={containerStyle} onMouseMove={this.handleMouseMove} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} ref={node => { this.container = node; }} >
      <img src={this.props.largeImageSrc} style={placeHolderStyle} onLoad={this.handlePlaceHolderLoad} />
      <img src={this.props.smallImageSrc} style={smallImageStyle} />
      <div style={largeImageStyle} />
    </div>
  );
}
}


/** WEBPACK FOOTER **
 ** ./src/js/components/ZoomImage.js
 **/